"use client";
import Skeleton from "react-loading-skeleton";
import {
  generateAbbreviation,
} from "../../lib/util";
import { useFetchMainAccessPoint } from "../../lib/services/access-point-service";
import { useOrganisationCategories } from "../../lib/services/product-service";
import styles from "./index.module.css";
import EmptyState from "../common/EmptyState";
import { useEffect, useState } from "react";
import Carousel from "../carousel/carousel";
import { useAppDispatch } from "../slice/hooks";
import { setActiveCategory } from "../slice/category-slice";

const CARD_WIDTH = "34rem";
const CARD_HEIGHT = "27rem";

const LoadingCategoryCard = ({ style }) => {
  return (
    <div
      style={{
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        borderRadius: 8,
        marginRight: "0.5rem",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        gap: "1rem",
        ...style,
      }}
    >
      <div style={{ width: "10rem", margin: "0 auto" }}>
        <Skeleton width={"100%"} height={20} />
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        <Skeleton
          width={"30rem"}
          height={"100%"}
          style={{ borderRadius: 8, display: "block" }}
        />
      </div>
    </div>
  );
};

const OrganisationCategories = ({ acc, token, handleSwitch }) => {
  const orgId = acc?.profileId;
  const accessPointId = acc?.accessPointId;
  const dispatch = useAppDispatch();

  const { data, isLoading } = useOrganisationCategories(
    orgId,
    token,
    accessPointId,
  );

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 5 }).map((_, i) => (
          <LoadingCategoryCard key={i} />
        ))}
      </>
    );
  }

  const categories = data?.productCategories || [];
  if (!categories.length) {
    return (
      <EmptyState>
        There are no categories available for this Organisation
      </EmptyState>
    );
  }

  return categories.map((category) => {
    // Build media array for carousel
    const media = (category.products || [])
      ?.map((product) => product.media?.[0])
      .filter(Boolean)
      .map((m) => ({
        mediaUrl: m.mediaUrl,
        mediaThumb: m.mediaThumb,
        mediaName: m.mediaName,
        mediaType: m.mediaType,
        mediaExt: m.mediaExt,
        mediaWidth: m.mediaWidth,
        mediaHeight: m.mediaHeight,
        mediaTime: m.mediaTime,
        _id: m._id,
      }));
    const hasMedia = media.length > 0;

    return (
      <div
        key={category.categoryId}
        className={styles.organisationCategory}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(setActiveCategory(category.productCategoryId));
          handleSwitch(acc);
        }}
      >
        <h4>{category.name}</h4>

        {hasMedia ? (
          <div className={styles.organisationCategoryMedia}>
            <Carousel
              media={media}
              enablePreview={false}
              autoscroll={true}
              hideThumb={true}
              inMarketPlace={true}
              galleryContainerClassName="organisation-category-gallery"
            />
          </div>
        ) : (
          <div className={styles.organisationCategoryMedia}>
            <div className={styles.organisationCategoryInitial}>
              {generateAbbreviation(category.name)}
            </div>
          </div>
        )}
      </div>
    );
  });
};

export default OrganisationCategories;
